module.exports = __webpack_public_path__ + "assets/img/22.c4d5c88a.png";